/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAStopIcon64Regular = forwardRef('MediaUiAStopIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 18.5A9.5 9.5 0 0 1 18.5 9h27a9.5 9.5 0 0 1 9.5 9.5v27a9.5 9.5 0 0 1-9.5 9.5h-27A9.5 9.5 0 0 1 9 45.5v-27Zm9.5-6.5a6.5 6.5 0 0 0-6.5 6.5v27a6.5 6.5 0 0 0 6.5 6.5h27a6.5 6.5 0 0 0 6.5-6.5v-27a6.5 6.5 0 0 0-6.5-6.5h-27Z" })));
});
